<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>Profile Help</h2>
    <button mat-icon-button fxLayoutAlign="end center" (click)="close()">
        <mat-icon aria-label="Close" class="headerIconButton">close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialogContent">
    <mat-card class="profileCard">
        <mat-card-content class="mainStepperCardContent" style="background: #f2f2f2;">
            <mat-card class="stepperCard">
                <mat-card-header>
                    <mat-card-title>The Photo uploaded will be used for your JCU Identification Card (ID)</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div fxLayout="column">
                        <div fxLayout="row">
                            <p>Please follow the guidelines below to ensure that your photo is in the correct format</p>
                        </div>
                        <div fxLayout="row" fxFlex="100%" class="liRow">
                            <div fxLayout="column" fxFlex="60%">
                                <ul class="marginTop0">
                                    <li>Face the camera directly, show your full face, front view, both eyes open with natural expression (smile if you like).</li>
                                    <li>Show full head from top of hair to bottom of chin; height of head should measure 1 inch to 13/8 inch (25 mm to 35 mm-80% of the photo should be your head and shoulder).</li>
                                    <li>Center head within frame without a hat, sunglasses, headphones, hand-free devices, or items cover or cast shadows.</li>
                                    <li>Use plain white or off-white background.</li>
                                    <li>Make sure there are no distracting shadows on the face or background.</li>
                                    <li>Full-color photo taken in the last 3 months.</li>
                                    <li>JPG format.</li>
                                </ul>
                            </div>
                            <div fxLayout="column" fxFlex="40%">
                                <div fxLayout="row" fxFlex="100%">
                                    <img title="Passport - USA" src="./assets/sample profile image.png" alt="Passport - USA" width="100%" height="auto" class="center">
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" fxFlex="100%" class="liRow">
                            <p class="wordBreak"><strong>Photos containing nudity, drug use, violence or other graphic content or uploading a photo of someone else other than yourself will incur disciplinary action.</strong></p>
                        </div>
                        <div fxLayout="row" fxFlex="100%" class="liRow">
                            <p class="wordBreak"><strong>Uploading a passport-quality photo is mandatory for your registration. If a substandard photo is uploaded, the photo will be rejected, and it <u>will result in longer processing time during your Orientation check-in process</u>.</strong></p>
                        </div>
                    </div>
                </mat-card-content>
                <!--<mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>Samples</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="column">
                            <div fxLayout="row" fxFlex="100%">
                                <img title="Passport - USA" src="./assets/sample profile image.png" alt="Passport - USA" width="30%" height="auto" class="center">
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>-->
            </mat-card>
        </mat-card-content>
        <mat-divider class="dividerColor"></mat-divider>
        <mat-card-actions fxLayoutAlign="end center">
            <button class="mat-raised-button dialogActionButton" mat-button color="primary" (click)="close()" type="button">Close</button>
        </mat-card-actions>
    </mat-card>
</mat-dialog-content>
